
export default {
    name: 'FinAgentSnippetPreview',

    props: {
        snippetId: {
            type: Number,
            default: null,
        },
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
    },

    computed: {
        openIcon() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/fin-agent-snippet-open-dark.svg') :
                require('@/assets/icons/fin-agent-snippet-open-light.svg');
        },
    },

    methods: {
        handleClickOpen() {

        }
    },
}
